import { DestinationHeroSlider } from '../../__utils/sliders';


// GLOBAL APP CONTROLLER
const controller = {
    init() {
        DestinationHeroSlider.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
